import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { DmcMasterApi } from "api/dmcMaster.api";
import { toast } from "react-toastify";
import { CityDBSearch } from "components/afterLogin/dashboard/staffDashboard/master/CityDBSearch";
import { TourOptionByCitySelector } from "dmcMaster/tourOptions/TourOptionsByCitySelector";
import {
  IDMCTourOption,
  IDMCTourOptionWithActivity,
  IGetTourOpitonParams,
  sharingBasisEnum,
  TDMCCombo,
  TDMCComboTourOption,
} from "commonFnBcode/types/dmc.types";

type FormValues = {
  city: string;
  selectedTours: number[];
};

export const CreateNewCombo: React.FC<{
  comboId?: number;
  isModalOpen: boolean;
  handleModalClose: () => void;
  refreshCombos?: number;
}> = (props) => {
  const [comboTourOptions, setComboTourOptions] = useState<
    Array<{
      tourOption: IDMCTourOptionWithActivity;
      onwardTransfer?: sharingBasisEnum;
      returnTransfer?: sharingBasisEnum;
    }>
  >([]);

  const [inputTourOptionData, setInputTourOptionData] =
    useState<IDMCTourOptionWithActivity>();

  const [tourOptionTransfer, setTourOptionTransfer] = useState<{
    onward?: sharingBasisEnum;
    return?: sharingBasisEnum;
  }>();

  const [selectedCityId, setSelectedCityId] = useState<number>();

  const [comboName, setComboName] = useState<string>("");
  const [comboAmount, setComboAmount] = useState<string>("");

  //   const [comboState, comboState] = useState(second)

  const handleCitySelect = (cityId: string) => {
    setSelectedCityId(parseInt(cityId));
  };

  const addTourToCombo = () => {
    if (!inputTourOptionData) {
      toast.error("Please select a tour option");
      return;
    }
    if (
      !comboTourOptions.find((t) => t.tourOption.id === inputTourOptionData.id)
    ) {
      setComboTourOptions((opt) => {
        return [
          ...opt,
          {
            tourOption: inputTourOptionData,
            onwardTransfer: tourOptionTransfer?.onward,
            returnTransfer: tourOptionTransfer?.return,
          },
        ];
      });
      setTourOptionTransfer(undefined);
      setInputTourOptionData(undefined);
    } else {
      toast.error("Tour already added");
    }
  };

  const saveCombo = async () => {
    try {
      let amtInt = +parseFloat(comboAmount);
      if (isNaN(amtInt)) {
        toast.error("Please enter a valid amount");
        return;
      }

      let tourOptions: TDMCComboTourOption[] = [];

      comboTourOptions.forEach((tourOpt) => {
        if (tourOpt.tourOption.id) {
          tourOptions.push({
            tourOptionId: tourOpt.tourOption.id,
            onwardTransfer: tourOpt.onwardTransfer as
              | sharingBasisEnum.private
              | sharingBasisEnum.sharing,
            returnTransfer: tourOpt.returnTransfer as
              | sharingBasisEnum.private
              | sharingBasisEnum.sharing,
          });
        }
      });

      const payload: TDMCCombo = {
        name: comboName,
        amount: amtInt,
        tourOptions: tourOptions,
      };
      const comboCreated = await DmcMasterApi.createCombo(payload);
      if (comboCreated.success) {
        toast.success("Combo created successfully");
        props.handleModalClose();
      } else {
        toast.error(comboCreated.errorMessage);
      }
    } catch (error) {
      toast.error("Failed to create combo");
    }
  };

  return (
    <div>
      <Modal show={props.isModalOpen} onHide={props.handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {props.comboId ? "Edit Combo" : "Create New Combo"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* Combo Name */}
                <Form.Group controlId="comboName">
                  <Form.Label>Combo Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter combo name"
                    value={comboName}
                    onChange={(e) => {
                      setComboName(e.target.value);
                    }}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row align-items-center my-3">
              <div className="col-9">
                <div className="container-fluid p-0">
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group controlId="citySearch">
                        <CityDBSearch
                          label="Select City"
                          // inputValue={
                          //   selectedCityId?.city
                          //     ? `${prevComboState?.city.city}, ${prevComboState?.city.country}`
                          //     : undefined
                          // }
                          onSelect={(cityId) => handleCitySelect(cityId)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group controlId="tourOptions">
                        <TourOptionByCitySelector
                          label="Select Tour Options"
                          selectedCityId={selectedCityId}
                          onSelect={(tourOption) => {
                            setInputTourOptionData(tourOption);
                          }}
                          value={inputTourOptionData?.id}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6 pt-3">
                      {/* Transfer Type */}
                      <Form.Group controlId="transferType">
                        <Form.Label>Onward Transfer</Form.Label>
                        <Form.Control
                          as="select"
                          onChange={(e) => {
                            setTourOptionTransfer({
                              ...tourOptionTransfer,
                              onward: e.target.value as sharingBasisEnum,
                            });
                          }}
                        >
                          <option value="">No Transfer</option>
                          {/* <option value={}>No Transfer</option> */}
                          <option value={sharingBasisEnum.private}>
                            Private
                          </option>
                          <option value={sharingBasisEnum.sharing}>
                            Sharing
                          </option>
                        </Form.Control>
                      </Form.Group>
                    </div>
                    <div className="col-md-6 pt-3">
                      {/* Transfer Type */}
                      <Form.Group controlId="transferType">
                        <Form.Label>Return Transfer</Form.Label>
                        <Form.Control
                          as="select"
                          onChange={(e) => {
                            setTourOptionTransfer({
                              ...tourOptionTransfer,
                              return: e.target.value as sharingBasisEnum,
                            });
                          }}
                        >
                          <option value="">No Transfer</option>
                          {/* <option value={}>No Transfer</option> */}
                          <option value={sharingBasisEnum.private}>
                            Private
                          </option>
                          <option value={sharingBasisEnum.sharing}>
                            Sharing
                          </option>
                        </Form.Control>
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <Button
                  onClick={() => {
                    addTourToCombo();
                  }}
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  Add
                </Button>
              </div>
            </div>
            <hr />
            <div className="row mt-3">
              <div className="col-12 mb-3">
                <h5>Selected Tour Options</h5>
              </div>
              {!comboTourOptions.length && (
                <div className="col-12">No Tour Options Added</div>
              )}
              {comboTourOptions.map((comboOption, optIndex) => (
                <div className="col-12" key={comboOption.tourOption.id}>
                  <div className="d-flex align-items-center mb-2">
                    {optIndex + 1}. {comboOption.tourOption.activity?.name} (
                    {comboOption.tourOption.name}) (
                    <i className="fa fa-arrow-circle-up mx-1"></i>
                    {comboOption.onwardTransfer
                      ? comboOption.onwardTransfer
                      : "No Transfer"}
                    <i className="fa fa-arrow-circle-down ms-3 me-1"></i>
                    {comboOption.returnTransfer
                      ? ` ${comboOption.returnTransfer}`
                      : "No Transfer"}{" "}
                    )
                    <div
                      style={{
                        cursor: "pointer",
                        float: "right",
                        marginLeft: "10px",
                      }}
                      className="text-danger"
                      // variant="danger"
                      onClick={() => {
                        setComboTourOptions(
                          comboTourOptions.filter(
                            (t) => t.tourOption.id !== comboOption.tourOption.id
                          )
                        );
                      }}
                    >
                      <i className="fas fa-trash"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <hr />

            <Form.Group controlId="amount">
              <Form.Label>Total Amount</Form.Label>
              <Form.Control
                type="text"
                placeholder="Amount"
                value={comboAmount}
                onChange={(e) => {
                  setComboAmount(e.target.value);
                }}
              />
              {/* {errors.comboName && (
                        <Form.Text className="text-danger">
                          Combo name is required
                        </Form.Text>
                      )} */}
            </Form.Group>

            <div>
              <Button
                className="mt-4"
                type="button"
                variant="primary"
                size="lg"
                onClick={() => {
                  saveCombo();
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
